var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65481",
    "data-name": "Group 65481",
    transform: "translate(-1010 -240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5554",
    "data-name": "Rectangle 5554",
    width: 28,
    height: 28,
    transform: "translate(1010 240)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34364",
    "data-name": "Path 34364",
    d: "M29.664,23.8a4.685,4.685,0,0,0,.558-.033v7.182a1.664,1.664,0,0,1-1.675,1.65H10.675A1.664,1.664,0,0,1,9,30.949v-11a1.664,1.664,0,0,1,1.675-1.65h14a4.475,4.475,0,0,0-.034.55,4.884,4.884,0,0,0,1.1,3.088L20.8,26.8a1.7,1.7,0,0,1-2.371,0l-6.238-6.143a.566.566,0,0,0-.79,0,.545.545,0,0,0,0,.778l6.238,6.143a2.829,2.829,0,0,0,3.948,0l4.943-4.867A5.07,5.07,0,0,0,29.664,23.8Zm0-8.8a3.85,3.85,0,1,0,3.909,3.85A3.884,3.884,0,0,0,29.664,15Z",
    transform: "translate(1002.193 229.77)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbucket);
export default __webpack_public_path__ + "static/media/mailbucket.f35e7a0430a58632d15bfa26dfd7836c.svg";
export { ForwardRef as ReactComponent };